import { useEffect } from "react"
import { Fragment } from "react/jsx-runtime"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../../ui/molecules/textArea"
import { GetByIdPersonalManagement } from "../../slice"
import { OtherDataCreation, OtherDataValidation, resetOtherDataCreationRequest, resetOtherDataCreationStatus, resetOtherDataErrors, resetOtherDataValidationStatus, setOtherDataCommitmentStatement, setOtherDataProtocolIdEntry } from "../slice"

interface Props {
    close: () => void;
}

export function OtherDataPopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const otherDataState = useAppSelector(state => state.PMOtherData)
    const PMState = useAppSelector(state => state.personalManagement)

    useEffect(() => {
        if (otherDataState.otherDataValidationStatus === 'successfully') {
            dispatch(resetOtherDataValidationStatus())
            dispatch(resetOtherDataErrors())
            dispatch(OtherDataCreation(otherDataState.otherDataCreationRequest))
        }
    }, [otherDataState.otherDataValidationStatus])

    useEffect(() => {
        if (otherDataState.otherDataCreationStatus === 'successfully') {
            dispatch(resetOtherDataCreationRequest())
            dispatch(resetOtherDataCreationStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [otherDataState.otherDataCreationStatus])

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">

                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="entry"
                        onSelect={(value) => dispatch(setOtherDataProtocolIdEntry(value))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note"
                        error={otherDataState.otherDataErrors.commitmentStatement}
                        supportingText={otherDataState.otherDataErrors.commitmentStatement ? 'Note mancanti' : undefined}
                        onChangeText={(text) => dispatch(setOtherDataCommitmentStatement(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetOtherDataErrors())
                            dispatch(resetOtherDataCreationRequest())
                            props.close()
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(OtherDataValidation(otherDataState.otherDataCreationRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}